import { Button, useColorModeValue, ButtonProps } from '@chakra-ui/react';
import React from 'react';

import { ConfigFormState } from '../types';

type AddConfigButtonProps = {
  title: string;
  configs: ConfigFormState[];
  setConfig: React.Dispatch<React.SetStateAction<ConfigFormState[]>>;
  isRelative?: boolean;
};
export const AddConfigButton = ({
  title,
  configs,
  setConfig,
  isRelative = false,
  ...buttonProps
}: AddConfigButtonProps & ButtonProps) => {
  const color = useColorModeValue('gray.800', 'gray.300');
  const allValid = configs.every((c) => c.isValid);
  return (
    <Button
      variant="link"
      fontSize="sm"
      fontWeight="medium"
      color={color}
      justifyContent="flex-start"
      isDisabled={!allValid}
      onClick={() =>
        setConfig((current) => [
          ...current,
          { isValid: false, isRelative, touched: false },
        ])
      }
      {...buttonProps}
    >
      {title}
    </Button>
  );
};
